
/* =========================================================
   DU_TANGO FEATURED PRODUCTS - SWIPER
========================================================= */

(() => {
  const instances = new Map();

  function initFeaturedProducts(root) {
    if (typeof Swiper === 'undefined') return;

    const sections = root.matches?.('[data-featured-products]')
      ? [root]
      : root.querySelectorAll('[data-featured-products]');

    sections.forEach((section) => {
      const slider = section.querySelector('[data-featured-swiper]');
      const navigation = section.querySelector('[data-featured-navigation]');
      const prev = section.querySelector('[data-featured-prev]');
      const next = section.querySelector('[data-featured-next]');

      if (!slider || instances.has(section)) return;

      const updateNavigation = (swiper) => {
        if (!navigation) return;

        navigation.hidden = swiper.isLocked;
      };

      const swiper = new Swiper(slider, {
        slidesPerView: 1.4,
        spaceBetween: 16,
        speed: 600,
        watchOverflow: true,
        resistanceRatio: 0.5,
        grabCursor: true,

        navigation: {
          prevEl: prev,
          nextEl: next
        },

        breakpoints: {
          750: {
            slidesPerView: 2.5,
            spaceBetween: 24
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 32
          }
        },

        on: {
          init(swiper) {
            updateNavigation(swiper);
          },
          lock(swiper) {
            updateNavigation(swiper);
          },
          unlock(swiper) {
            updateNavigation(swiper);
          },
          resize(swiper) {
            updateNavigation(swiper);
          }
        }
      });

      instances.set(section, swiper);
    });
  }

  function destroyFeaturedProducts(root) {
    const sections = root.matches?.('[data-featured-products]')
      ? [root]
      : root.querySelectorAll('[data-featured-products]');

    sections.forEach((section) => {
      const swiper = instances.get(section);

      if (swiper) {
        swiper.destroy(true, true);
        instances.delete(section);
      }
    });
  }

  function initialize() {
    initFeaturedProducts(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initFeaturedProducts(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyFeaturedProducts(event.target);
  });
})();
